import http from "@/http";
import eventBus from "@/events";

const Company = {
    findAll: async function (ctx) {
        if(ctx) {
            const page = ctx.currentPage - 1 || 0;
            const size = ctx.perPage || 20;
            const sortDesc = ctx.sortDesc ? ',desc' : '';
            const sort = (ctx.sortBy || 'name') + sortDesc;
            const filter = ctx.filter ? ctx.filter : {};
            const pagination = {page, size, sort, sortDesc};
            const params = {...filter, ...pagination};
            const resp = await http("/companies/search/all", {params});
            eventBus.$emit('LIST_COUNT_COMPANY_EVENT', resp.data.page.totalElements);
            return resp.data._embedded.companies;
        } else {
            const resp = await http("/companies/search/all");
            eventBus.$emit('LIST_COUNT_COMPANY_EVENT', resp.data.page.totalElements);
            return resp.data._embedded.companies;
        }
    },
    async getDonors() {
        try{
            const resp = await http.get('/companies/search/donors');
            return resp.data._embedded.companies;
        } catch (e) {
            console.error(e);
        }
    },
    async getSuppliers() {
        try{
            const resp = await http.get('/companies/search/suppliers');
            return resp.data._embedded.companies;
        } catch (e) {
            console.error(e);
        }
    },
    create: function(data) {
        return http.post('/companies', data);
    },
    update: function (id, data) {
        return http.patch('/companies/' + id, data);
    },
    findById(id) {
        return http.get('/companies/' + id);
    },
    enable(id) {
        return http.patch('/companies/' + id + '/enable')
    },
    disable(id) {
        return http.patch('/companies/' + id + '/disable')
    },
    deleteById(id) {
        return http.delete('/companies/' + id)
    },
    findCompanyAccounts: function(id) { return http.get('undefined'.replace('{id}', id)); },
    getCompanyType(type) {
        switch (+type){
            case 0:
                return 'COMPANY_TYPE_DONOR_LABEL';
            case 1:
                return 'COMPANY_TYPE_SUPPLIER_LABEL';
            case 2:
                return 'COMPANY_TYPE_DONOR_SUPPLIER_LABEL';
            default:
                return 'COMPANY_TYPE_UNKNOWN_LABEL';
        }
    }
};

export default Company;
